module.exports = __webpack_public_path__ + "img/beer_id-68.ca4a9aba.png";